import { Flex, Text } from "@jsq/ds/core";
import { RowItem, TypedAGGridCellRenderParams } from "../types";
import { programStyle } from "./styles_vanilla.css";

interface Props {
  params: TypedAGGridCellRenderParams<RowItem> | { value: string | undefined };
}

export const ProgramNameRenderer = ({ params: { value } }: Props) => {
  const displayValue = value && value !== "None" ? value : "--";

  return (
    <Flex alignItems="center">
      <Text data-testid="program-name" className={programStyle}>
        {displayValue}
      </Text>
    </Flex>
  );
};
